import { MessagePrimitive } from '@assistant-ui/react';

import { AssistantActionBar } from './AssistantActionBar.tsx';
import { BranchPicker } from './BranchPicker.tsx';
import { ChatErrorFallback } from './ChatErrorFallback.tsx';
import { CollapsibleMessageParts } from './CollapsibleMessageParts.tsx';
import classes from './Thread.module.css';

/**
 * Renders an assistant message with tool displays, error handling, and branch navigation.
 * Dynamically renders message parts (text, tool calls) using assistant-ui primitives.
 */
export function AssistantMessage() {
  // TODO: Animated message parts
  return (
    <MessagePrimitive.Root className={classes.messageContainer} data-role="assistant">
      <div className={classes.contentWrapper}>
        <div className={classes.messageParts}>
          <CollapsibleMessageParts />

          {/* Error display inside bubble area with standardized UI */}
          <MessagePrimitive.Error>
            <ChatErrorFallback />
          </MessagePrimitive.Error>
        </div>

        <div className={classes.assistantFooter}>
          {/* Motion wrapper enables animation on action bar visibility changes */}
          <AssistantActionBar />

          <BranchPicker />
        </div>
      </div>
    </MessagePrimitive.Root>
  );
}
